<template>
  <div class="thumb portrait">
    <a
      href="javascript:void(0)"
      role="button"
      @click.prevent="$emit('on-click')"
    >
      <div v-if="checkValidRank" class="rank-area" aria-hidden="true">
        <img :src="rankingImgUrl" :alt="rankingImgAlt" />
      </div>
      <div class="thumb-image">
        <div class="picture-area">
          <WebpImage
            :image-info="{
              imageUrl: cellInfo.thumbnail,
              width: thumbnailInfo.width,
              height: thumbnailInfo.height,
              alt: altTitle,
              className: 'thumb-img',
              onImageLoad,
            }"
          />
        </div>
        <div
          class="no-thumb"
          :aria-hidden="!isImageLoaded"
          :style="`display: ${displayCss}`"
        >
          <span class="alt-text">{{ alt }}</span>
        </div>
        <ul class="badge-list">
          <li class="left-top-area">
            <ul v-top-tag-list="topTagList"></ul>
          </li>
          <li
            v-common-tag-list="{ badgeList: brandTagList, type: 'brand' }"
            class="right-top-area"
          ></li>
        </ul>
      </div>
      <div class="sub-title a11y-hidden">
        <div
          v-title-list="{
            titleList: titleList,
            cellType: 'portrait',
            callback: loaded,
          }"
          class="sub-right"
        ></div>
      </div>
    </a>
  </div>
</template>
<script>
  import _ from 'lodash'
  import {
    bandTitle,
    titleList,
    commonTagList,
    topTagList,
  } from '@/common/resources/directives'
  import CellMixIn from '@/mixins/cell.mixin'
  import shave from 'shave'
  import WebpImage from '@/components/image/WebpImage'
  export default {
    name: 'PortraitRankingCell',
    components: { WebpImage },
    directives: {
      bandTitle,
      titleList,
      commonTagList,
      topTagList,
    },
    mixins: [CellMixIn],
    props: {
      cellInfo: {
        type: Object,
      },
      sectionInfo: {
        type: Object,
      },
      thumbnailInfo: {
        type: Object,
      },
      cellIndex: {
        type: Number,
      },
    },
    computed: {
      rankValue() {
        return this.cellInfo?.rank ?? ''
      },
      checkValidRank() {
        const candidate = Array.from({ length: 20 }, (_, i) => `${i + 1}`)
        return candidate.findIndex((el) => el === this.rankValue) !== -1
      },
      rankingImgUrl() {
        return this.checkValidRank
          ? require(
              `@/assets/images/main/portrait-rank/portrait-rank-${this.rankValue}@3x.png`,
            )
          : ''
      },
      rankingImgAlt() {
        return this.checkValidRank ? `랭킹 ${this.rankValue}위` : ''
      },
    },
    methods: {
      loaded(el) {
        this.$nextTick(() => {
          _.forEach(el.querySelectorAll('.line1'), (line1El) => {
            shave(line1El, 28)
          })
        })
      },
    },
  }
</script>
<style lang="scss" src="@/assets/scss/import/portrait.scss"></style>
<style lang="scss">
  @import '@/assets/scss/import/mixin';
  .rank-area {
    @include Position(absolute, $left: 0, $right: 0, $bottom: -32px);
    z-index: 2;
    height: 76px;
    text-align: left;
    transform: translateZ(0);
    z-index: 20;
    img {
      height: 100%;
      margin: 0;
    }
  }
</style>
